/* =========================================================================================================
   NJ: video in a "Large product" card (collection grid, snippets/product-card.liquid + sections/main-collection.liquid)
   - No controls; plays muted and in a loop while the card is in view, pauses when it scrolls out of view.
   - The video lies over the card's first image. When the customer swipes / uses the arrows (assets/nj-theme-custom.js
     changes data-card-media-index on the card) it is hidden and paused, and it comes back on the way back to the start.
   - Clicks go through to the product link (pointer-events: none in the CSS).
   - Customers who ask for reduced motion (system setting) see the image instead.
   A custom element, so cards added by "Load more" work automatically.
   ========================================================================================================= */
(() => {
  'use strict';

  if (customElements.get('nj-card-video')) return;

  const reducedMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  class NjCardVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.card = this.closest('product-card');
      if (!this.video || !this.card) return;

      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = true;
      this.video.playsInline = true;
      this.video.removeAttribute('controls');
      this.video.setAttribute('playsinline', '');
      this.video.setAttribute('tabindex', '-1');

      this.homeIndex = this.card.dataset.cardMediaIndex || '0';
      this.inView = false;

      // Watch the card media box (this element can be display:none while hidden, which would stop the observer)
      const target = this.parentElement || this.card;
      this.io = new IntersectionObserver((entries) => {
        this.inView = entries.some((entry) => entry.isIntersecting);
        this.update();
      }, { threshold: 0.2 });
      this.io.observe(target);

      this.mo = new MutationObserver(() => this.update());
      this.mo.observe(this.card, { attributes: true, attributeFilter: ['data-card-media-index'] });

      this.update();
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.mo) this.mo.disconnect();
    }

    update() {
      if (!this.video || !this.card) return;

      const atHome = (this.card.dataset.cardMediaIndex || '0') === this.homeIndex;
      this.hidden = !atHome || Boolean(reducedMotion && reducedMotion.matches);

      if (!this.hidden && this.inView) {
        if (this.video.paused) {
          const playing = this.video.play();
          if (playing && playing.catch) playing.catch(() => {});
        }
      } else if (!this.video.paused) {
        this.video.pause();
      }
    }
  }

  customElements.define('nj-card-video', NjCardVideo);
})();
